import React, { useState, useEffect } from 'react'
import ProgressBar from './ProgressBar'
import axios from 'axios'

const News = () => {
    const [data, setData] = useState([])
    const [upload, setUpload] = useState(false)
    const [uploadpercents, setUploadPercents] = useState(0)
    const [uploadError, setUploadError] = useState(null)
    const [message, setMessage] = useState('')
    const [image, setImage] = useState(null)  

    const fetchData = async () => {
        try {
            const ACTION_URL = `https://www.durgacollege.in/dashboard/backend/fetch_news.php`;
            const res = await fetch(ACTION_URL, {method:'GET'})
            const data = await res.json()
            if (res.status === 200 && data) {
                setData(data)
            }
        } catch (error){
            console.log(error);
        }
    }

    useEffect(() => {
        fetchData()
        document.title = 'News | Durga College Admin panel'
    }, [])

    const submitEvent = async e => {
        e.preventDefault()
        try {
            if(image) {
                setUpload(true)
                const fd = new FormData(e.target)
                fd.append('action', 'addNews')
                const res = await axios.post('https://www.durgacollege.in/dashboard/backend/action.php', fd, {
                    onUploadProgress: progressEvent => {
                        const { loaded, total } = progressEvent
                        let percent = Math.round( (loaded * 100 ) / total)
                        setUploadPercents(percent)                   
                    }
                })
                console.log('Response:', res.data);
                if (res.status === 200 && res.data.status){
                    setMessage(<div className="mb-3 success-message">{res.data.message}</div>)
                    setImage(null)
                    fetchData()
                    setTimeout(() => {
                        setUploadPercents(0)    
                    }, 2000);  
                } else {
                    setUploadError('#a02b31')
                    setMessage(<div className="mb-3 error-message">{res.data.message}</div>)
                }
                setUpload(false)
            }
        } catch (error) {
            setMessage(<div className="mb-3 error-message">{error.message}</div>)
            setUpload(false)
        }
    }

    return (
        <div className="news">
        { 
            uploadpercents ? <ProgressBar uploadpercents={uploadpercents} uploadError={uploadError} /> : null
        }
            <h3 className="mb-3"><i className="bi bi-image-fill"></i> News</h3>
            <div id="message">{message}</div>
            <form method="post" className="mb-3" onSubmit={submitEvent}>
                <div className="mb-3">
                    <label htmlFor="imageFile" className="form-label">Choose Image : *</label>
                    <input
                        type="file"
                        name="imageFile"
                        className="form-control"
                        accept="image/*"
                        onChange={e => setImage(e.target.files[0])} 
                    />
                </div> 
                <button type="submit" className="btn btn-primary">
                {
                    !upload ? 'Upload' : 'Uploading...'
                }
                </button>
            </form>
            <hr/>
            <div className="d-flex flex-nowrap">
            {
                data.map((elem, idx) => {
                    return (
                        <div className="image-box" key={idx}>
                            <img src={`https://www.durgacollege.in/images/durga_news/${elem.image_name}`} alt={idx} />
                        </div>
                    )
                })
            }
            </div>
        </div>
    )
}

export default News
